import { getUniqueLink } from '../../app/helpers/string'

/**
 * ProductTourAddSlideCtrl controller
 */
// controller mixins
ProductTourAddSlideCtrl.mixes = [
  'FileUploadMixin'
]

/**
 * ProductTourAddSlideCtrl controller
 *
 * @class ProductTourAddSlideCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 * @mixes mwApp/common.mixin:FileUploadMixin
 *
 * @ngdoc controller
 * @name mwApp/productTour.controller:ProductTourAddSlideCtrl
 */
/* @ngInject */
export default function ProductTourAddSlideCtrl ($scope, $uibModal, $uibModalInstance, alertLiteSvc, productTourSlide, isNew) {
  const vm = this
  vm.productTourSlide = productTourSlide
  vm.isNew = isNew

  // Upload images

  vm.uploadPoster = function (file, properties = {}, setUrl) {
    vm.setDisable()
    const _URL = window.URL || window.webkitURL

    const parts = properties.parts
    const fileSize = properties.fileSize || 10485760
    const fileSizeName = properties.fileSizeName || `${fileSize} bytes`
    const type = properties.type

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / parts.width
      const heightPart = this.height / parts.height
      _URL.revokeObjectURL(objectUrl)

      if (fileSize && file.size > fileSize) {
        alertLiteSvc.alertError(`File bigger than ${fileSizeName}`)
        $scope.$broadcast('dndfile.clear', true)
        vm.unsetDisable()
        return
      }

      if (widthPart && heightPart && (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02)) {
        alertLiteSvc.alertError(`Aspect ratio must be ${parts.width}:${parts.height}`)
        $scope.$broadcast('dndfile.clear', true)
        vm.unsetDisable()
        return
      }

      return vm._uploadFile('api/product-tour/upload', file, { type }).data()
        .then((response) => {
          const url = getUniqueLink(response.resourceUrl)
          setUrl(url)
        })
        .finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
    $scope.form.$setDirty()
  }

  vm.uploadVerticalImageUrl = function (file) {
    return vm.uploadPoster(file, { parts: { width: 2, height: 3 }, fileSizeName: '10 Mb', type: 'VERTICAL' }, (url) => { productTourSlide.verticalImageUrl = url })
  }

  vm.uploadHorizontalImageUrl = function (file) {
    return vm.uploadPoster(file, { parts: { width: 16, height: 9 }, fileSizeName: '10 Mb', type: 'HORIZONTAL' }, (url) => { productTourSlide.horizontalImageUrl = url })
  }

  /**
   * Save changes, close modal window
   *
   * @memberof mwApp/packages.controller:ProductTourAddSlideCtrl
   */
  vm.submit = function () {
    $uibModalInstance.close({ productTourSlide })
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/packages.controller:ProductTourAddSlideCtrl
   */
  vm.cancel = function ($event) {
    $event.preventDefault()
    $uibModalInstance.dismiss('cancel')
  }
}
